module.exports = __webpack_public_path__ + "static/img/A42.18022dc6.jpg";